import React from 'react';

const SportsIcon = ({ size = '24px', className = '' }) => {
  return (
    <svg 
      className={className}
      fill="none" 
      height={size} 
      viewBox="0 0 24 24" 
      width={size} 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path 
        className="Ui-bottomHalf" 
        d="m13.2875 10.146-2.1299-.79873-2.44946 2.98193 1.77846 2.6731.3515.5431 3.738-.9904.213-3.8339zm0 0-2.1299-.79873-2.44946 2.98193 1.77846 2.6731.3515.5431 3.738-.9904.213-3.8339zm3.557-6.1662c-1.2393-.64669-2.617-.9829-4.0149-.97977-2.1557-.00545-4.23848.77989-5.8539 2.20723-1.61543 1.42735-2.65128 3.39759-2.91135 5.53754-.26007 2.1399.27371 4.3009 1.50021 6.0736 1.22651 1.7728 3.06058 3.0341 5.15484 3.5452 2.0942.511 4.3031.2363 6.2083-.7722s3.3744-2.6807 4.1293-4.6999.743-4.2451-.0333-6.25608c-.7764-2.01102-2.2633-3.66748-4.1792-4.65562zm2.2897 10.9266-3.1097.9372-.3301 2.524c-1.1618.5192-2.4434.7107-3.7061.5538l-1.4591-2.0235-1.29922.2663-.93718.1917c-1.03162-.8353-1.80981-1.9417-2.24709-3.195l1.22472-1.8424-1.40577-2.2896c.31561-1.25563.96299-2.40326 1.87436-3.32277v.33015l3.12038.80938 2.0341-2.52399-.5644-.67093h.5005c1.1089.00336 2.2021.26209 3.1949.75613.5706.28857 1.1036.64624 1.5868 1.06497l-1.5122.30884v3.19492l2.9499 1.3206.7988-1.065c.0986.4909.1485.9903.1491 1.491.0194 1.1616-.2476 2.3101-.7775 3.344zm-7.9447-5.55913-2.44941 2.98193 1.74651 2.6731.3515.5431 3.738-.9904.213-3.8339-1.5016-.5751zm2.13.79873-2.13-.79873-2.44941 2.98193 1.74651 2.6731.3515.5431 3.738-.9904.213-3.8339zm0 0-2.13-.79873-2.44941 2.98193 1.74651 2.6731.3515.5431 3.738-.9904.213-3.8339z" 
        fill="var(--color-primary)"
      />
      <path 
        className="Ui-topHalf" 
        clipRule="evenodd" 
        d="m11.1896 9.34741 2.0979.79869-2.8008 4.8563-1.74659-2.6731z" 
        fill="var(--color-primary)" 
        fillRule="evenodd"
      />
      <path 
        className="Ui-topHalf" 
        clipRule="evenodd" 
        d="m16.8445 3.9798-.82 1.37381c-.9972-.47563-2.0902-.7161-3.1949-.70288h-.5006l.5645.71353-2.0341 2.48139-3.13104-.80938v-.33014c-.91137.91951-1.55875 2.06714-1.87436 3.32267l1.40577 2.2578-1.21407 1.8424c.43728 1.2532 1.21547 2.3597 2.24709 3.1949l.93718-.1917-1.16082 2.0341c-1.59265-1.0287-2.80978-2.5451-3.46962-4.3226-.65985-1.7774-.727-3.7207-.19142-5.53948.53557-1.81879 1.64513-3.41553 3.16296-4.55176 1.51784-1.13623 3.36253-1.75098 5.25853-1.75244 1.3979-.00313 2.7756.33309 4.0149.97978z" 
        fill="var(--color-primary)" 
        fillRule="evenodd"
      />
      <path 
        className="Ui-innerFill" 
        d="m19.8691 10.2952-.7988 1.065-2.95-1.3206v-3.19488l1.5443-.35144c-.4833-.41872-1.0162-.7764-1.5869-1.06497-1.007-.50944-2.1195-.7757-3.2481-.77743h-.5006l.5645.71353-2.0341 2.48139-3.13104-.80938v-.33014c-.91137.91951-1.55875 2.06714-1.87436 3.32272l1.40577 2.2577-1.21407 1.8424c.43728 1.2533 1.21547 2.3597 2.24709 3.195l.93718-.1917 1.29923-.2663 1.4697 2.0235c1.2628.1569 2.5444-.0346 3.7061-.5538l.3195-2.4921 3.0991-.9371.0852.1597c.5271-1.0128.8012-2.1383.7987-3.2801.0029-.5003-.0434-.9997-.1384-1.491zm-5.3249 4.2599-3.7381.9905-.3514-.5432-1.71462-2.6731 2.44942-2.98189 2.13.79869 1.5016.5751z" 
        fill="transparent"
      />
    </svg>
  );
};

export default SportsIcon;
